module.exports = __webpack_public_path__ + "media/images/icons/empty-star-5d94199436c3df8c111b00dda10b6a92.svg";